class Verification {
	constructor() {
		this.stepFirst = $(".js-v-page-first");
		this.firstInputs = this.stepFirst.find(".form-group.required .enter__input");
		this.helpBlocks = this.stepFirst.find(".form-group.required .help-block");
		this.stepSecond = $(".js-v-page-second");
		this.stepThird = $(".js-v-page-third");
		this.buttonFirst = $(".js-v-button-first");
		this.buttonSecond = $(".js-v-button-second");
		this.step = $(".js-v-step");
		this.info = $(".js-v-info");
		this.$purchaseItems = $(".purchase__item");
	}

	init() {
		this.setUpListeners();
		this.purchaseCheckboxes();
	}

	setUpListeners() {
		this.buttonFirst.on("click", () => {
			setTimeout(() => {
				let hasErrors = false;

				$.each(this.helpBlocks, (index, item) => {
					if (!$(item).is(':empty')) {
						hasErrors = true;
					}
				})

				$.each(this.firstInputs, (index, item) => {
					if ($(item).val().trim() === "") {
						hasErrors = true;
					}
				})
				if (!hasErrors) {
					this.stepFirst.hide();
					this.stepSecond.show();
					this.step.eq(0)
						.removeClass("active")
						.addClass("passed");
					this.step.eq(1).addClass("active");
				}
			}, 200)

		});

		this.buttonSecond.on("click", () => {
			this.stepSecond.hide();
			this.stepThird.show();
			this.step.eq(1)
				.removeClass("active")
				.addClass("passed");
			this.step.eq(2).addClass("active");
			this.info.text(this.getWord("main", "Check verification")).addClass("check");
		});

		$(".js-info-icon").on("click", e => {
			const infoText = $(e.target.parentNode.nextElementSibling);
			const info = infoText.parents(".info");
			infoText.toggleClass("active");
			info.toggleClass("active");
		});

		$(document).mouseup(e => {
			const container = $(".js-info-icon");
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				$(".info__text").removeClass("active");
				const info = $(".info__text").parents(".info");
				info.removeClass("active");
			}
		});
	}

	updatePurchaseSum(item) {
		const purchaseCheckboxes = $(item).find(".js-purchase-checkbox");
		const purchaseSum = $(item).find("#purchaseSum");
		let totalSum = 0;
		$.each(purchaseCheckboxes, (i, item) => {
			if ($(item).prop('checked')) {
				let price = $(item).attr('data-price');
				if ((+price) > 0) {
					totalSum = totalSum + (+price);
				}
			}
		});
		$(purchaseSum).text(totalSum);
	}

	purchaseCheckboxes() {
		for (let i = 0; i < this.$purchaseItems.length; i++) {
			const purchaseItem = $(this.$purchaseItems[i]);
			const purchaseSum = purchaseItem.find("#purchaseSum");
			const purchaseCheckboxes = purchaseItem.find(".js-purchase-checkbox");
			const purchaseClear = purchaseItem.find(".js-purchase-clear");
			const purchaseAll = purchaseItem.find(".js-purchase-all");
			const items = purchaseCheckboxes.length;
			purchaseClear.on("click", () => {
				purchaseCheckboxes.prop("checked", false);
				purchaseAll.prop("checked", false);
				this.updatePurchaseSum(purchaseItem);
			});

			purchaseAll.on("change", () => {
				purchaseCheckboxes.prop("checked", true);
				this.updatePurchaseSum(purchaseItem);
			});

			purchaseCheckboxes.on("change", () => {
				let length = 0;
				$.each(purchaseCheckboxes, (i, item) => {
					if ($(item).is(":checked")) {
						length++;
					}
				});
				if (length < items) {
					purchaseAll.prop("checked", false);
				} else {
					purchaseAll.prop("checked", true);
				}
				this.updatePurchaseSum(purchaseItem);
			});
		}
	}
}

export const verification = new Verification();

